import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import ExpiredLinkIcon from '@/images/ExpiredLinkIcon.svg?react';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { envConfig } from '@/config/envConfig';
import { CONTACT_MOBILE_PHONE, FORMATTED_CONTACT_MOBILE_PHONE } from '@/const/shared';
import { ModalWindow } from '@/components/ModalWindow/ModalWindow';

type CancelSubscriptionModalType = {
  isOpen: boolean;
  onClose: () => void;
};

export const CancelSubscriptionModal = ({ isOpen, onClose }: CancelSubscriptionModalType) => {
  return (
    <ModalWindow isOpen={isOpen} width='510px'>
      <Box display='flex' flexDirection='column' alignItems='center' rowGap='24px'>
        <ExpiredLinkIcon />
        <Box display='flex' flexDirection='column' rowGap='16px'>
          <Typography variant='headline4' color={COLORS.black} fontWeight='semibold'>
            Need to Cancel Your Subscription?
          </Typography>
          <Box display='flex' flexDirection='column' rowGap='12px'>
            <Typography color={COLORS.black} fontWeight='medium'>
              To cancel your subscription, please contact{' '}
              <NavigationLink to={`mailto:${envConfig.SUPPORT_EMAIL_URL}`} size='large'>
                {envConfig.SUPPORT_EMAIL_URL}{' '}
              </NavigationLink>{' '}
              or call{' '}
              <NavigationLink to={`tel:${CONTACT_MOBILE_PHONE}`} size='large'>
                {FORMATTED_CONTACT_MOBILE_PHONE}{' '}
              </NavigationLink>
              .
            </Typography>
            <Typography variant='bodySmall' color={COLORS.grey[700]}>
              Once we receive your request, a WireVault support team member will cancel your subscription. The{' '}
              <b>cancellation</b> of your subscription will take <b>effect</b> when your current{' '}
              <b>billing cycle ends</b>. Until that date all Admins of your organization will retain the functionality
              depending on the current status of the subscription in the WireVault.
            </Typography>
            <Typography variant='bodySmall' color={COLORS.grey[700]}>
              After the cancellation becomes effective all Admins will lose access to premium features and their
              accounts will switch to <b>view-only mode</b>.
            </Typography>
            <Typography variant='bodySmall' color={COLORS.grey[700]}>
              After your subscription cancellation, you can <b>reactivate</b> it at any time.
            </Typography>
          </Box>
        </Box>
        <Button onClick={onClose}>Return to Billing</Button>
      </Box>
    </ModalWindow>
  );
};
